module.exports = __webpack_public_path__ + "img/clock-red.9a334b79.svg";